import { render } from "./DSW.vue?vue&type=template&id=ab93dcb2"
import script from "./DSW.vue?vue&type=script&lang=js"
export * from "./DSW.vue?vue&type=script&lang=js"

import "./DSW.vue?vue&type=style&index=0&id=ab93dcb2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__